import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import {
  Button,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { BackButton, Details } from '../../../../components';
import { Menu } from '../../../../types/menus';
import { updateMenu } from '../../../menu/slice';
import { useAppDispatch, useAppSelector } from '@/hooks';

type FormValues = Partial<Menu>;

const Settings = () => {
  const dispatch = useAppDispatch();
  const { menuId } = useParams();
  const menu = useAppSelector((state) => state?.menus[menuId ?? '']);

  const initialValues: Partial<Menu> = {};

  const formik = useFormik({
    initialValues,
    onSubmit: () => {
      const values: FormValues = { ...formik.values };
      dispatch(updateMenu(values));
    },
  });

  useEffect(() => {
    if (menu) {
      formik.setValues({
        id: menuId,
        title: menu.title,
        isPublished: !!menu.isPublished,
      });
    }
  }, [menu, menuId]);

  return (
    <Stack spacing={2} py={4} height={'100vh'}>
      <Typography variant="h1">Settings</Typography>
      <BackButton />

      <Stack flexDirection={'row'} height={'50px'} alignItems={'space-between'}>
        <Details
          label="Título"
          children={
            <TextField
              margin="normal"
              name="title"
              value={formik.values.title}
              onChange={formik.handleChange}
            />
          }
        />
      </Stack>

      <Stack flexDirection={'row'} height={'50px'}>
        <Details
          label={'Status'}
          description={
            menu?.isPublished ? 'Si está Publicado' : 'No está Publicado'
          }
          children={
            <FormControlLabel
              control={
                <Switch
                  name="isPublished"
                  checked={formik.values.isPublished}
                  onChange={formik.handleChange}
                />
              }
              label="Publicado"
            />
          }
        />
      </Stack>
      <Button variant="contained" onClick={formik.handleSubmit}>
        Guardar
      </Button>
    </Stack>
  );
};

export default Settings;
